exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3mvLlIjeFABfhNNLMiROI9{margin:20px}._7L8xjnYf6DEptbdv2l--e{color:#616161}._2uxolG4giz8lPZQKW9ngZm{margin:8px 0 10px 0}\n", ""]);

// Exports
exports.locals = {
	"inner": "_3mvLlIjeFABfhNNLMiROI9",
	"header": "_7L8xjnYf6DEptbdv2l--e",
	"text": "_2uxolG4giz8lPZQKW9ngZm"
};